import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

class BragifyAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultImg: false,
    };
  }

  componentDidMount() {
    const self = this;
    const img = new Image();
    img.onerror = () => {
      self.setState({ defaultImg: true });
    };

    const { src } = this.props;

    img.src = src;
  }

  render() {
    const { defaultImg } = this.state;
    const { src } = this.props;
    if (defaultImg) {
      return <FontAwesomeIcon icon={faUserCircle} />;
    }
    return <img src={src} alt="Avatar" />;
  }
}

export default BragifyAvatar;
